import { createContext } from "react";

export interface PeopleContextState {
  projectId: string;
}

export const PeopleContext = createContext<PeopleContextState>({
  projectId: "",
});
